/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindJobPositionLevelQueryResponse } from './FindJobPositionLevelQueryResponse';
import {
    FindJobPositionLevelQueryResponseFromJSON,
    FindJobPositionLevelQueryResponseFromJSONTyped,
    FindJobPositionLevelQueryResponseToJSON,
} from './FindJobPositionLevelQueryResponse';

/**
 * 
 * @export
 * @interface DataFindJobPositionLevelQueryResponse
 */
export interface DataFindJobPositionLevelQueryResponse {
    /**
     * 
     * @type {Array<FindJobPositionLevelQueryResponse>}
     * @memberof DataFindJobPositionLevelQueryResponse
     */
    data: Array<FindJobPositionLevelQueryResponse>;
}

/**
 * Check if a given object implements the DataFindJobPositionLevelQueryResponse interface.
 */
export function instanceOfDataFindJobPositionLevelQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function DataFindJobPositionLevelQueryResponseFromJSON(json: any): DataFindJobPositionLevelQueryResponse {
    return DataFindJobPositionLevelQueryResponseFromJSONTyped(json, false);
}

export function DataFindJobPositionLevelQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataFindJobPositionLevelQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FindJobPositionLevelQueryResponseFromJSON)),
    };
}

export function DataFindJobPositionLevelQueryResponseToJSON(value?: DataFindJobPositionLevelQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(FindJobPositionLevelQueryResponseToJSON)),
    };
}

